module.exports = __webpack_public_path__ + "static/unfollow-bb2a8bb10a58592568b6a1b0a876b111.jpg";